import { RootState } from 'handlers';

export const getBankAccount = ({ bankAccount }: RootState) => bankAccount;
